export type Lang = 'en' | 'ar'

export const t = {
  en: {
    // Nav
    nav: {
      about: 'ABOUT',
      services: 'SERVICES',
      projects: 'PROJECTS',
      fleet: 'FLEET & ASSETS',
      certifications: 'CERTIFICATIONS',
      contact: 'CONTACT',
    },
    // Footer
    footer: {
      contact: 'Contact',
      quickLinks: 'Quick Links',
      tagline: '100% Saudi-owned contractor serving the oil & gas industry since 2008',
      rights: 'All rights reserved.',
    },
    // Hero
    hero: {
      name1: 'RBOUA',
      name2: 'ALSMAN',
      name3: 'CONTRACTING EST.',
      subtitle: 'Saudi Arabia\'s trusted partner in Oil & Gas construction, heavy civil works, and industrial infrastructure since 2008.',
      viewProjects: 'VIEW PROJECTS',
      contactUs: 'CONTACT US',
      stats: {
        founded: 'Year Founded',
        experience: 'Years Experience',
        team: 'Team Members',
        machines: 'Heavy Machines',
      },
    },
    // About
    about: {
      badge: 'WHO WE ARE',
      title: 'About RAC',
      p1: 'Rboua Alsman Contracting Establishment (RAC) is a 100% Saudi-owned company with 17+ years of experience delivering oil & gas construction, heavy civil works, and industrial infrastructure across the Kingdom of Saudi Arabia.',
      p2: 'As a trusted partner of Saudi Aramco, we operate 500+ heavy machines and deploy a skilled workforce of 305+ professionals, maintaining the highest standards of safety, quality, and environmental responsibility.',
      ceoQuote: '"Excellence is not a destination but a continuous journey of improvement, innovation, and commitment to our clients and our nation."',
      ceoName: 'CEO, Rboua Alsman Contracting Est.',
      mission: 'Mission',
      missionText: 'Deliver world-class contracting services for the oil & gas sector with unwavering commitment to safety, quality, and environmental stewardship.',
      vision: 'Vision',
      visionText: 'To be the most trusted and innovative contracting partner in Saudi Arabia, contributing to Vision 2030 through excellence and sustainability.',
      values: 'Values',
      valuesText: 'Safety First · Quality Excellence · Environmental Responsibility · Integrity · Innovation · Saudi Ownership Pride',
      milestones: 'Key Milestones',
    },
    // Services
    services: {
      badge: 'WHAT WE DO',
      title: 'Our Services',
      subtitle: 'Comprehensive contracting solutions for the oil & gas and construction sectors.',
    },
    // Projects
    projects: {
      badge: 'OUR WORK',
      title: 'Projects',
      subtitle: 'A track record of successful project delivery for Saudi Aramco and major clients.',
      ongoing: 'Ongoing Projects',
      completed: 'Completed Projects',
      client: 'Client',
      location: 'Location',
      period: 'Period',
      type: 'Type',
    },
    // Fleet
    fleet: {
      badge: 'CAPABILITIES',
      title: 'Fleet & Assets',
      subtitle: '500+ heavy machines and certified personnel deployed across Saudi Arabia.',
      equipment: 'Equipment Inventory',
      personnel: 'Certified Personnel',
    },
    // Certifications
    certifications: {
      badge: 'CREDENTIALS',
      title: 'Certifications & Awards',
      subtitle: 'Recognized for excellence in quality, safety, and environmental management.',
      certs: 'Certifications',
      awards: 'Awards',
      registrations: 'Registrations',
    },
    // Org Chart
    org: {
      badge: 'STRUCTURE',
      title: 'Organization Chart',
    },
    // Contact
    contact: {
      badge: 'REACH US',
      title: 'Contact Us',
      subtitle: 'Get in touch with our team for inquiries and project discussions.',
      headOffice: 'Head Office & Camp',
      mobile: 'Mobile / WhatsApp',
      email: 'Email',
      emergency: 'Emergency Contacts',
      registration: 'Company Registration Details',
      crNumber: 'CR Number',
      vendorNo: 'Vendor No. (Aramco)',
      vatReg: 'VAT Registration',
      scaMembership: 'SCA Membership',
      poBox: 'P.O. Box',
      whatsapp: 'Available for WhatsApp',
    },
  },

  ar: {
    // Nav
    nav: {
      about: 'من نحن',
      services: 'خدماتنا',
      projects: 'المشاريع',
      fleet: 'الأسطول والأصول',
      certifications: 'الشهادات',
      contact: 'تواصل معنا',
    },
    // Footer
    footer: {
      contact: 'التواصل',
      quickLinks: 'روابط سريعة',
      tagline: 'مقاول سعودي 100% يخدم قطاع النفط والغاز منذ عام 2008',
      rights: 'جميع الحقوق محفوظة.',
    },
    // Hero
    hero: {
      name1: 'مؤسسة ربوع',
      name2: 'الأسمان',
      name3: 'للمقاولات',
      subtitle: 'الشريك الموثوق في المملكة العربية السعودية لإنشاءات النفط والغاز والأعمال المدنية الثقيلة والبنية التحتية الصناعية منذ عام 2008.',
      viewProjects: 'عرض المشاريع',
      contactUs: 'تواصل معنا',
      stats: {
        founded: 'سنة التأسيس',
        experience: 'سنوات الخبرة',
        team: 'أعضاء الفريق',
        machines: 'آلة ثقيلة',
      },
    },
    // About
    about: {
      badge: 'من نحن',
      title: 'عن الشركة',
      p1: 'مؤسسة ربوع آلصمان للمقاولات (RAC) شركة سعودية 100٪ تمتلك خبرة تزيد على 17 عاماً في تنفيذ مشاريع إنشاء النفط والغاز والأعمال المدنية الثقيلة والبنية التحتية الصناعية في جميع أنحاء المملكة العربية السعودية.',
      p2: 'بوصفنا شريكاً موثوقاً لشركة أرامكو السعودية، نشغّل أكثر من 500 آلة ثقيلة ونوظّف كوادر بشرية ماهرة تضم أكثر من 305 محترفين، مع التزامنا الراسخ بأعلى معايير السلامة والجودة والمسؤولية البيئية.',
      ceoQuote: '"التميز ليس وجهةً بل رحلة مستمرة من التحسين والابتكار والالتزام تجاه عملائنا ووطننا."',
      ceoName: 'الرئيس التنفيذي، مؤسسة ربوع آلصمان للمقاولات',
      mission: 'رسالتنا',
      missionText: 'تقديم خدمات مقاولات عالمية المستوى لقطاع النفط والغاز مع التزام راسخ بالسلامة والجودة والمسؤولية البيئية.',
      vision: 'رؤيتنا',
      visionText: 'أن نكون الشريك المقاولاتي الأكثر ثقة وابتكاراً في المملكة العربية السعودية، مساهمين في تحقيق رؤية 2030 من خلال التميز والاستدامة.',
      values: 'قيمنا',
      valuesText: 'السلامة أولاً · التميز في الجودة · المسؤولية البيئية · النزاهة · الابتكار · الفخر بالملكية السعودية',
      milestones: 'أبرز المحطات',
    },
    // Services
    services: {
      badge: 'ما نقدمه',
      title: 'خدماتنا',
      subtitle: 'حلول مقاولات متكاملة لقطاعي النفط والغاز والإنشاءات.',
    },
    // Projects
    projects: {
      badge: 'أعمالنا',
      title: 'المشاريع',
      subtitle: 'سجل حافل بإنجازات ناجحة لصالح أرامكو السعودية وكبار العملاء.',
      ongoing: 'المشاريع الجارية',
      completed: 'المشاريع المنجزة',
      client: 'العميل',
      location: 'الموقع',
      period: 'الفترة',
      type: 'النوع',
    },
    // Fleet
    fleet: {
      badge: 'قدراتنا',
      title: 'الأسطول والأصول',
      subtitle: 'أكثر من 500 آلة ثقيلة وكوادر معتمدة منتشرة في أرجاء المملكة.',
      equipment: 'قائمة المعدات',
      personnel: 'الكوادر المعتمدة',
    },
    // Certifications
    certifications: {
      badge: 'اعتماداتنا',
      title: 'الشهادات والجوائز',
      subtitle: 'معتمدون في الجودة والسلامة والإدارة البيئية.',
      certs: 'الشهادات',
      awards: 'الجوائز',
      registrations: 'التسجيلات',
    },
    // Org Chart
    org: {
      badge: 'الهيكل التنظيمي',
      title: 'الهيكل التنظيمي',
    },
    // Contact
    contact: {
      badge: 'تواصل معنا',
      title: 'اتصل بنا',
      subtitle: 'تواصل مع فريقنا للاستفسارات ومناقشة المشاريع.',
      headOffice: 'المكتب الرئيسي والمعسكر',
      mobile: 'الجوال / واتساب',
      email: 'البريد الإلكتروني',
      emergency: 'جهات الاتصال الطارئة',
      registration: 'بيانات تسجيل الشركة',
      crNumber: 'رقم السجل التجاري',
      vendorNo: 'رقم المورد (أرامكو)',
      vatReg: 'رقم تسجيل ضريبة القيمة المضافة',
      scaMembership: 'عضوية SCA',
      poBox: 'صندوق البريد',
      whatsapp: 'متاح على واتساب',
    },
  },
} as const
